import { Injectable } from "@angular/core";
import { Utilities } from "@tylertech/shared-module";
import { NavigationService } from "@tylertech/core-module";

@Injectable({ providedIn: "root" })
export abstract class ResetStateService
{
    constructor(readonly $navigationService: NavigationService)
    {
        $navigationService.onResetState()
            .subscribe(() => this.reset());
    }

    reset(): void
    {
        Object.keys(this).filter(f => this._ignored.indexOf(f) < 0 && !this.isServiceInjection(f) && !this.isSubject(f))
            .forEach(key =>
            {
                let value = (this as any)[key];
                if (Utilities.IsNullOrUndefined(value))
                    value = undefined;
                else if (typeof value === "boolean")
                    value = false;
                else if (typeof value === "number")
                    value = 0;
                else if (Array.isArray(value))
                    value = [];
                else if (Utilities.isObject(value))
                    value = {};
                else
                    value = undefined;
                (this as any)[key] = value;
            });
        this.reInitialize();
    }

    protected reInitialize(): void { return; }

    protected ignored: string[] = [];

    private get _ignored(): string[]
    {
        const ret = [
            "ignored",
            "_ignored"
        ];

        if (this.ignored.length > 0)
            return ret.concat(...this.ignored);
        return ret;
    }

    isServiceInjection(property: string): boolean
    {
        return property.startsWith("$");
    }

    isSubject(property: string): boolean
    {
        return property.endsWith("$");
    }
}
